import SvgIcon from "../../SvgIcon/SvgIcon";
import { useProductSizes } from "../../../hooks/product/useProductSizes";
import ProductSizePopup from "../../Catalog/size/ProductSizePopup";

interface Props {
  onSizeCreated?: (data: { id?: number; code: string; name: string }) => Promise<void> | void;
  onReload?: () => void;
  message?: string;
}

const QuickAddProductSize: React.FC<Props> = ({
  onSizeCreated,
  onReload,
  message = "¿No encuentras la talla que buscas? Puedes agregar una nueva.",
}) => {

  const { isCreateModalOpen, openCreateProductSize, closeCreateProductSize } = useProductSizes();

  return (
    <div className="mt-1 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      {/* Mensaje contextual */}
      <p className="text-gray-600 dark:text-gray-300 text-xs">{message}</p>

      {/* Botones */}
      <div className="flex items-center gap-2">
        {/* Verde — Recargar */}
        <button
          onClick={onReload}
          type="button"
          className="inline-flex items-center gap-1 rounded bg-[#3CA745] py-1 px-2 text-xs font-medium text-white hover:bg-opacity-90 transition"
        >
          <SvgIcon name="refresh" className="h-3 w-3" />
          Recargar
        </button>

        {/* Azul — Nueva */}
        <button
          onClick={openCreateProductSize}
          type="button"
          className="inline-flex items-center gap-1 rounded bg-primary py-1 px-2 text-xs font-medium text-white hover:bg-opacity-90 transition"
        >
          <SvgIcon name="plus" className="h-3 w-3" />
          Nueva talla
        </button>
      </div>

      {/* Modal */}
      <ProductSizePopup
        isOpen={isCreateModalOpen}
        close={closeCreateProductSize}
        onSubmit={onSizeCreated}
      />
    </div>
  );
};

export default QuickAddProductSize;
